import type { DashboardVM } from '../../lib/compute';
import { KpiCard } from '../ui';

export function Produkte({ vm }: { vm: DashboardVM }) {
  return (
    <>
      <div className="cw-pagehead">
        <h1>Produkte</h1>
        <span className="meta">SKU-Konsolidierung über {vm.channelsFiltered ? 'gewählte' : 'alle'} Kanäle · {vm.rangeCaption}</span>
      </div>

      {vm.amazonProductsPending && (
        <div className="cw-roas-note warn">
          Amazon-Artikeldaten (SKU/ASIN) noch nicht angebunden — Amazon-Spalte folgt mit dem Order-Items-Abruf.
        </div>
      )}

      <div className="cw-kpi3">
        {vm.productKpis.map((k) => (
          <KpiCard key={k.label} kpi={k} large />
        ))}
      </div>

      <section className="cw-card" style={{ padding: '8px 24px 12px', marginBottom: 20 }}>
        <div className="cw-card-head" style={{ padding: '14px 0 0' }}>
          <h2>Produktumsatz nach Kanal</h2>
          <span className="meta">
            netto · zusammengeführt über SKU
            {vm.countriesFiltered && !vm.productExactFilters ? ' · Länderfilter hier nicht anwendbar' : ''}
            {vm.countriesFiltered && vm.productExactFilters ? ' · gewählte Länder' : ''}
          </span>
        </div>
        <div className="cw-table-scroll" style={{ marginTop: 10 }}>
          <table className="cw-table" style={{ minWidth: 480 }}>
            <thead>
              <tr>
                <th className="l">Produkt</th>
                {vm.productChannels.map((c) => (
                  <th key={c} className="r">{c}</th>
                ))}
                <th className="r">Gesamt</th>
              </tr>
            </thead>
            <tbody>
              {vm.productSales.map((p) => (
                <tr key={p.sku}>
                  <td className="l kw" title={p.sku}>{p.name}</td>
                  {p.cells.map((v, i) => (
                    <td key={i} className={`r${vm.productChannels[i] === 'Amazon' && vm.amazonProductsPending ? ' muted' : ''}`}>{v}</td>
                  ))}
                  <td className="r roas">{p.total}</td>
                </tr>
              ))}
              {vm.productSales.length === 0 && (
                <tr>
                  <td className="l" colSpan={vm.productChannels.length + 2} style={{ color: '#A8A39D' }}>
                    Keine Produktumsätze in der gewählten Kanal-Auswahl.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      <section className="cw-card" style={{ padding: '22px 24px' }}>
        <div className="cw-card-head" style={{ marginBottom: 14 }}>
          <h2>
            Heatmap: Land × Produkt <span style={{ color: '#A8A39D', fontWeight: 400 }}>· Umsatz</span>
          </h2>
          <span className="meta">
            {vm.heatmapRangeAware ? vm.rangeCaption : 'gesamter Zeitraum'}
            {vm.heatmapChannelAware
              ? vm.channelsFiltered ? ' · gewählte Kanäle' : ' · alle Kanäle'
              : ` · immer alle Kanäle${vm.channelsFiltered ? ' (Kanalfilter hier nicht anwendbar)' : ''}`}
          </span>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table className="cw-heat">
            <thead>
              <tr>
                <th className="l">Land</th>
                {vm.heatmap.products.map((p) => (
                  <th key={p} className="r">{p}</th>
                ))}
                <th className="sum">Σ</th>
              </tr>
            </thead>
            <tbody>
              {vm.heatmap.rows.map((r) => (
                <tr key={r.country}>
                  <td className="land">{r.country}</td>
                  {r.cells.map((c, i) => (
                    <td
                      key={i}
                      className={`cell ${c.empty ? 'empty' : 'val'}`}
                      style={c.empty ? undefined : { background: `rgba(231,165,105,${c.alpha})` }}
                    >
                      {c.label}
                    </td>
                  ))}
                  <td className="total">{r.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="cw-heat-note">
          Farbintensität = relative Stärke pro Zeile (Land).{' '}
          {vm.heatmapChannelAware
            ? 'Echte Umsätze je Kanal und Land (Amazon nach Marketplace der Bestellung, cosyworld.com nach Rechnungsland der Bestellung, OTTO = Deutschland). Folgt Zeitraum-, Kanal- und Länderfilter — nur Länder und Produkte mit Umsatz in der Auswahl.'
            : vm.heatmapRangeAware
              ? 'Alle Kanäle (cosyworld.com, Amazon, OTTO, WooCommerce), echte Umsätze je Land (Amazon nach Marketplace der Bestellung, cosyworld.com nach Rechnungsland der Bestellung). Folgt dem gewählten Zeitraum und Länderfilter — nur Produkte mit Umsatz im Zeitraum.'
              : 'Heatmap nutzt den vollen Datenbereich, nicht den Zeitfilter oben.'}
        </div>
      </section>
    </>
  );
}
